var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC3A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 24.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "-C3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.09,18.89c.47.39,2.54,3.25,3.21,4.12.38.47.65,1.08,1.48,1.1,1,0,1.74-1.36,2.59-2.45l2.18-2.76c2.09-.1,4.48,0,6.6,0,1.69,0,4.28.32,4.73-1.53a37.32,37.32,0,0,0,0-5.2c0-1.72.12-9.43,0-10.45-.26-2-3-1.69-4.44-1.69H2.94C.07,0,.06,1.38.06,2.9V13.44c0,1.36-.34,3.89.54,4.76s3.87.68,5.81.68h6.68Z",
    transform: "translate(0.01 0)",
    fill: "#4d4d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.63,11.4a1.16,1.16,0,0,0,1.21,1.19h4.28a1.16,1.16,0,0,0,1.11-.68A3.87,3.87,0,0,0,12,9.55c-.1-.17-.08-.16-.2-.34a1.27,1.27,0,0,0-1.12-.58c-.28,0-1.34,1.34-3,.22a1,1,0,0,0-.43-.22,1.33,1.33,0,0,0-1.18.72,4.2,4.2,0,0,0-.42,2.05Z",
    transform: "translate(0.01 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.87,8.94a1.75,1.75,0,0,0,1.2-.35,1.61,1.61,0,0,0,.23-.22,1.65,1.65,0,0,0,.5-1.07c0-.09,0-.13,0-.22a2,2,0,0,0-.17-.72A1.39,1.39,0,0,0,10.38,6a1.81,1.81,0,0,0-2.16-.5,2.18,2.18,0,0,0-.52.36,1.16,1.16,0,0,0-.2.25,1.78,1.78,0,0,0-.31,1.41A1.83,1.83,0,0,0,8.88,8.94Z",
    transform: "translate(0.01 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC3A);
export default __webpack_public_path__ + "static/media/C3A.3ae755b8c09f1286e83bece4e1f4adeb.svg";
export { ForwardRef as ReactComponent };